import { useEffect, useState } from 'react';
import { ApiError, login, type Auth } from './api';
import { setLocale, t } from './i18n';
import { initData, tg } from './telegram';
import { Handover } from './screens/Handover';
import { Offer } from './screens/Offer';
import { Trip } from './screens/Trip';
import { Family } from './screens/Family';

/** Маршрут з hash (#/trip?t=…) або start_param (startapp=trip_<id>). */
export function parseRoute(hash: string, startParam?: string | null): { screen: string; params: URLSearchParams } {
  const h = hash.replace(/^#\/?/, '');
  if (h) {
    const [screen, q] = h.split('?');
    return { screen, params: new URLSearchParams(q ?? '') };
  }
  if (startParam) {
    const [screen, id] = startParam.split('_');
    const key = { trip: 't', offer: 'h', handover: 'case', family: 'case' }[screen] ?? 'id';
    return { screen, params: new URLSearchParams(id ? { [key]: id } : {}) };
  }
  return { screen: '', params: new URLSearchParams() };
}

export function App() {
  const [auth, setAuth] = useState<Auth | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [route, setRoute] = useState(() => parseRoute(window.location.hash));

  useEffect(() => {
    tg()?.ready();
    tg()?.expand();
    setLocale(tg()?.initDataUnsafe?.user?.language_code);
    login(initData())
      .then((a) => {
        setLocale(a.locale);
        setAuth(a);
        if (!window.location.hash) setRoute(parseRoute('', a.start_param ?? tg()?.initDataUnsafe?.start_param));
      })
      .catch((e: unknown) => setErr(e instanceof ApiError && e.status === 403 ? t('not_linked') : t('error')));
    const onHash = () => setRoute(parseRoute(window.location.hash));
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  if (err) return <div className="center">{err}</div>;
  if (!auth) return <div className="center">{t('loading')}</div>;

  const p = route.params;
  const screen = route.screen || { driver: 'trip', family: 'family', partner: 'offer', dispatcher: 'handover' }[auth.persona];
  if (screen === 'handover' && auth.persona === 'dispatcher' && p.get('case')) {
    return <Handover caseId={p.get('case')!} orgId={p.get('org')} />;
  }
  if (screen === 'offer' && p.get('h') && auth.persona !== 'family') return <Offer handoverId={p.get('h')!} />;
  if (screen === 'trip' && auth.persona === 'driver') return <Trip tripId={p.get('t')} />;
  if (screen === 'family' && auth.persona === 'family') return <Family caseId={p.get('case')} />;
  return <div className="center">{t('open_from_chat')}</div>;
}
